import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  column-gap: 0.3rem;
  margin-top: 8px;
`;
